import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Category from "../pages/Category";
import AddEditCategory from "../pages/Category/AddEdit";
import AddEditSubCategory from "../pages/Category/AddEditSubCategory";
import CategoryView from "../pages/Category/view";
import ViewSubCategory from "../pages/Category/ViewSubCategory";
import AddEditFaq from "../pages/cms/FaqManagement/AddEditFaq";
import FaqList from "../pages/cms/FaqManagement/List";
import AddEditEmailTemplate from "../pages/EmailTemplate/AddEditEmailTemplate";
import EmailTemplateList from "../pages/EmailTemplate/List";
import ViewEmailDetail from "../pages/EmailTemplate/ViewEmail";
import GlobalSetting from "../pages/Global Setting";
import AddEditUserManagement from "../pages/UserManagement/AddEditUser";
import UserManagementList from "../pages/UserManagement/List";
import ViewUserManagement from "../pages/UserManagement/ViewUser";
import DeletionRequestList from "../pages/UserManagement/DeletionRequests";
import InactiveUserList from "../pages/UserManagement/InactiveUsers";
import LeagueManagement from "../pages/LeagueManagement";
import AddEditLeagueManagement from "../pages/LeagueManagement/AddEdit";
import ViewAddEditLeagueManagement from "../pages/LeagueManagement/view";
import ContestManagement from "../pages/ContestManagement";
import HotContestManagement from "../pages/ContestManagement/HotContestManagement";
import ViewAddEditContestManagement from "../pages/ContestManagement/view";
import AddEditContestManagement from "../pages/ContestManagement/AddEdit";
import HowtoPlayList from "../pages/HowPlayManagement/List";
import AddEditHowToPlay from "../pages/HowPlayManagement/AddEditHowToPlay";
import ViewHowToplayDetail from "../pages/HowPlayManagement/ViewHowToPlay";
import JackpotManagementList from "../pages/JackpotManagement/List";
import AddEditJackpot from "../pages/JackpotManagement/AddEdit";
import ViewJackpotManagement from "../pages/JackpotManagement/view";
import TeamManagementList from "../pages/TeamManagement/List";
import EditPlayer from "../pages/TeamManagement/Edit";
import RevenueManagementList from "../pages/Earning&RevenueManagement/RevenueManagement";
import WalletManagementList from "../pages/WalletManagement/List";
import AllTrangectionList from "../pages/WalletManagement/AllTrangectionList";
import ViewTransactionDetail from "../pages/WalletManagement/ViewTransactionDetail";
import EditWallet from "../pages/WalletManagement/EditWallet";
import GameManagementList from "../pages/GameManagement/List";
import EditGame from "../pages/GameManagement/EditGame";
import ViewGameManagement from "../pages/GameManagement/View";
import WinnersJackpotManagement from "../pages/JackpotManagement/Winners";
import GamePointList from "../pages/GamePointManagement/List";
import AddEditGamePoint from "../pages/GamePointManagement/AddEdit";
import ViewGamePoint from "../pages/GamePointManagement/ViewGamePoint";
import PlayerList from "../pages/TeamManagement/Player";
import ReferralUserList from "../pages/ReferralManagement/List";
import UserList from "../pages/ReferralManagement/User";
import { Loader } from "../components/CustomLoader";
import NotificationList from "../pages/NotificationManagement/NotificationList";
import AddEditNotificationTemplate from "../pages/NotificationManagement/AddEditNotificationManagement";
import ViewNotificationDetail from "../pages/NotificationManagement/viewNotification";
import FriendManagement from "../pages/FriendManagement/FriendList";
import AboutUs from "../pages/cms/AboutUs";
import Chat from "../pages/ChatManagement/Chat";
import ViewFriendManagement from "../pages/FriendManagement/ViewFriend";
import FriendList from "../pages/ChatManagement/FriendList";
import ChatScreen from "../pages/ChatManagement/ChatView";
import LeaderboardScreen from "../pages/ContestManagement/Leaderboard";
import TeamPreviewScreen from "../pages/ContestManagement/TeamPreview";
import SupportChat from "../pages/SupportChat/SupportChat";
import FantasyGames from "../pages/ContestManagement/FantasyGame";
import WithdrawalRequestList from "../pages/PaymentWithdrawalRequest/List";
import BoostersManagementList from "../pages/BoostersManagement/List";
import AddEditBoostersManagement from "../pages/BoostersManagement/AddEditBoosters";
import ViewBoostersManagement from "../pages/BoostersManagement/ViewBoosters";
import ResponsibleGambling from "../pages/cms/ ResponsibleGambling";
import PlayerManagementList from "../pages/PlayerManagement/List";
import GemPackagesManagementList from "../pages/gemPackagesManagement/List";
import AddGemPackage from "../pages/gemPackagesManagement/AddGemPackage";
import AdminManagementList from "../pages/AdminManagement/List";
import AddEditAdmin from "../pages/AdminManagement/AddEdit";
import ChangeAdminPassword from "../pages/AdminManagement/ChangePassword";
import RoleGuard from "../components/RoleGuard";
import { ADMIN_ROLES } from "../utils/constants";
import { useSelector } from "react-redux";
import SportNewsList from "../pages/SportNewsManagement/List";
import AddEditSportNews from "../pages/SportNewsManagement/AddEditSportNews";
import ViewSportNews from "../pages/SportNewsManagement/ViewSportNews";

const CurrencyManagementList = lazy(() =>
  import("../pages/CurrencyManagement/List"),
);
const AddEditCurrency = lazy(() =>
  import("../pages/CurrencyManagement/AddEdit"),
);
const ViewCurrency = lazy(() => import("../pages/CurrencyManagement/View"));

const CoinPackagesManagementList = lazy(() =>
  import("../pages/CoinPackagesManagement/List"),
);
const AddEditCoinPackage = lazy(() =>
  import("../pages/CoinPackagesManagement/AddEdit"),
);
const ViewCoinPackage = lazy(() =>
  import("../pages/CoinPackagesManagement/View"),
);

const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

//CMS............................................................ ............................
const CmsPage = lazy(() => import("../pages/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/cms/AddEditCms"));

//MyAccount........................................................................................
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));

const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadingFallback = (
  <div>
    <Loader />
  </div>
);

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = () => {
  const user = useSelector((state) => state.auth.user);

  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        {
          element: (
            <Navigate
              to={
                user?.role === ADMIN_ROLES.JUNIOR
                  ? "/user-management"
                  : "/dashboard"
              }
            />
          ),
          index: true,
        },
        {
          path: "dashboard",
          element: (
            <RoleGuard
              allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.MGT]}
            >
              {makeLazyComponent(() => (
                <DashboardPage />
              ))}
            </RoleGuard>
          ),
        },
        // {
        //   path: "reset-password",
        //   element: makeLazyComponent(() => <ChangePassword />),
        // },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: (
            <RoleGuard
              allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.MGT]}
            >
              {makeLazyComponent(() => (
                <GlobalSetting />
              ))}
            </RoleGuard>
          ),
        },
        {
          path: "admin-management",
          children: [
            {
              index: true,
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AdminManagementList />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "add",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AddEditAdmin />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "edit/:id",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AddEditAdmin />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "change-password/:id",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <ChangeAdminPassword />
                  ))}
                </RoleGuard>
              ),
            },
          ],
        },
        {
          path: "user-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <UserManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewUserManagement />),
            },
            {
              path: "deletion-requests",
              element: makeLazyComponent(() => <DeletionRequestList />),
            },
            {
              path: "inactive-users",
              element: makeLazyComponent(() => <InactiveUserList />),
            },
          ],
        },
        {
          path: "player-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <PlayerManagementList />),
            },
          ],
        },
        {
          path: "revenue-management",
          element: makeLazyComponent(() => <RevenueManagementList />),
        },
        {
          path: "wallet-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <WalletManagementList />),
            },
            {
              path: "transaction-history/:id",
              element: makeLazyComponent(() => <AllTrangectionList />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewTransactionDetail />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <EditWallet />),
            },
          ],
        },
        {
          path: "payment-withdrawal-request",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <WithdrawalRequestList />),
            },
          ],
        },
        {
          path: "game-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <GameManagementList />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <EditGame />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewGameManagement />),
            },
          ],
        },

        {
          path: "contest-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <ContestManagement />),
            },
            {
              path: "hot-contest",
              element: makeLazyComponent(() => <HotContestManagement />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditContestManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditContestManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => (
                <ViewAddEditContestManagement />
              )),
            },
            {
              path: "leaderboard/:id",
              element: makeLazyComponent(() => <LeaderboardScreen />),
            },
            {
              path: "fantasy-games/:id",
              element: makeLazyComponent(() => <FantasyGames />),
            },
            {
              path: "team-preview/:id",
              element: makeLazyComponent(() => <TeamPreviewScreen />),
            },
          ],
        },

        {
          path: "support-chat",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <SupportChat />),
            },
          ],
        },

        {
          path: "league-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <LeagueManagement />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditLeagueManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditLeagueManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewAddEditLeagueManagement />),
            },
          ],
        },

        {
          path: "category",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <Category />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCategory />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCategory />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <CategoryView />),
            },
            {
              path: "add-subcategory/:categoryid",
              element: makeLazyComponent(() => <AddEditSubCategory />),
            },
            {
              path: "edit-subcategory/:id",
              element: makeLazyComponent(() => <AddEditSubCategory />),
            },
            {
              path: "view-subcategory/:id",
              element: makeLazyComponent(() => <ViewSubCategory />),
            },
          ],
        },

        {
          path: "jackpot-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <JackpotManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditJackpot />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditJackpot />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewJackpotManagement />),
            },
            {
              path: "winners-view/:id",
              element: makeLazyComponent(() => <WinnersJackpotManagement />),
            },
          ],
        },
        {
          path: "friend-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <FriendManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewFriendManagement />),
            },
          ],
        },
        {
          path: "team-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <TeamManagementList />),
            },

            {
              path: "edit/:id/:playerteamid",
              element: makeLazyComponent(() => <EditPlayer />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewJackpotManagement />),
            },
            {
              path: "player-view/:id/:seasonId",
              element: makeLazyComponent(() => <PlayerList />),
            },
          ],
        },

        {
          path: "referral-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <UserList />),
            },
            {
              path: "referral-user/:id",
              element: makeLazyComponent(() => <ReferralUserList />),
            },
          ],
        },

        {
          path: "how-to-play-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <HowtoPlayList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditHowToPlay />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditHowToPlay />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewHowToplayDetail />),
            },
          ],
        },

        {
          path: "email-template",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <EmailTemplateList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditHowToPlay />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditEmailTemplate />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewEmailDetail />),
            },
          ],
        },

        {
          path: "boosters-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <BoostersManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditBoostersManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditBoostersManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewBoostersManagement />),
            },
          ],
        },
        {
          path: "gem-packages",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <GemPackagesManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddGemPackage />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddGemPackage />),
            },
          ],
        },

        {
          path: "cms",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CmsPage />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCms />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCms />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewCms />),
            },
          ],
        },
        {
          path: "about-us",
          element: makeLazyComponent(() => <AboutUs />),
        },
        {
          path: "responsible-gambling",
          element: makeLazyComponent(() => <ResponsibleGambling />),
        },

        {
          path: "chat",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <Chat />),
            },
            {
              path: "friends/:id",
              element: makeLazyComponent(() => <FriendList />),
            },

            {
              path: "view/:id",
              element: makeLazyComponent(() => <ChatScreen />),
            },
          ],
        },

        {
          path: "notification-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <NotificationList />),
            },
            {
              path: "add",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AddEditNotificationTemplate />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "edit/:id",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AddEditNotificationTemplate />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewNotificationDetail />),
            },
          ],
        },
        {
          path: "faq",
          children: [
            { index: true, element: makeLazyComponent(() => <FaqList />) },
            { path: "add", element: makeLazyComponent(() => <AddEditFaq />) },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditFaq />),
            },
            // { path: "view/:id", element: makeLazyComponent(() => <ViewCourceManagement />), },
          ],
        },
        {
          path: "sport-news",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <SportNewsList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditSportNews />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditSportNews />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewSportNews />),
            },
          ],
        },
        {
          path: "game-point-management",
          children: [
            {
              element: makeLazyComponent(() => <GamePointList />),
              index: true,
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditGamePoint />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditGamePoint />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewGamePoint />),
            },
          ],
        },
        {
          path: "currency-management",
          children: [
            {
              index: true,
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <CurrencyManagementList />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "add",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AddEditCurrency />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "edit/:id",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <AddEditCurrency />
                  ))}
                </RoleGuard>
              ),
            },
            {
              path: "view/:id",
              element: (
                <RoleGuard allowedRoles={[ADMIN_ROLES.SUPER_ADMIN]}>
                  {makeLazyComponent(() => (
                    <ViewCurrency />
                  ))}
                </RoleGuard>
              ),
            },
          ],
        },
        {
          path: "coin-packages-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CoinPackagesManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCoinPackage />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCoinPackage />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewCoinPackage />),
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: (
        <Navigate
          to={
            user?.role === ADMIN_ROLES.JUNIOR
              ? "/user-management"
              : "/dashboard"
          }
        />
      ),
    },
  ];

  return useRoutes(routes);
};

export default MainRouting;
